import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MobileCredentials from './mobile-credentials-model'
import {
  CreateMobileCredentialsAsync,
  DeleteMobileCredentialsAsync,
  LoadMobileCredentialssAsync,
} from './mobileCredentials-thunk'
const initialState: mobileCredentialsSliceState = {
  mobileCredentials: [],
  selected_mobileCredentials: '',
  is_loading_mobileCredentials: false,
  is_creating_mobileCredentials: false,
  is_deleting_mobileCredentials: false,
}
export interface mobileCredentialsSliceState {
  mobileCredentials: MobileCredentials[]
  selected_mobileCredentials?: string
  is_loading_mobileCredentials: boolean
  is_creating_mobileCredentials: boolean
  is_deleting_mobileCredentials: boolean
}
export const mobileCredentialsSlice = createSlice({
  name: 'mobileCredentials',
  initialState,
  reducers: {
    setSelectedmobileCredentials: (state, action) => {
      state.selected_mobileCredentials = action.payload
    },
    clearStatemobileCredentials: (state) => {
      state.mobileCredentials = []
      state.is_loading_mobileCredentials = false
      state.is_creating_mobileCredentials = false
      state.is_deleting_mobileCredentials = false
    },
    mergemobileCredentials: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mobileCredentials = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mobileCredentials = merge(
            state.mobileCredentials,
            payload,
          ) as any
        }
      }
    },

    add_mobileCredentials: (state, action) => {
      if (action.payload) {
        state.mobileCredentials = [...state.mobileCredentials, action.payload]
      }
    },
    set_mobileCredentials: (state, action) => {
      let { key, value, id } = action.payload
      state.mobileCredentials = state.mobileCredentials.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMobileCredentialssAsync.pending, (state) => {
      state.is_loading_mobileCredentials = true
    })
    builder.addCase(LoadMobileCredentialssAsync.fulfilled, (state, action) => {
      state.is_loading_mobileCredentials = false
      if (action.payload) {
        state.mobileCredentials = action.payload
      }
    })
    builder.addCase(LoadMobileCredentialssAsync.rejected, (state) => {
      state.is_loading_mobileCredentials = false
    })
    builder.addCase(CreateMobileCredentialsAsync.pending, (state) => {
      state.is_creating_mobileCredentials = true
    })
    builder.addCase(CreateMobileCredentialsAsync.fulfilled, (state) => {
      state.is_creating_mobileCredentials = false
    })
    builder.addCase(CreateMobileCredentialsAsync.rejected, (state) => {
      state.is_creating_mobileCredentials = false
    })
    builder.addCase(DeleteMobileCredentialsAsync.pending, (state) => {
      state.is_deleting_mobileCredentials = true
    })
    builder.addCase(DeleteMobileCredentialsAsync.fulfilled, (state, action) => {
      state.is_deleting_mobileCredentials = false
      if (state.mobileCredentials) {
        state.mobileCredentials = state.mobileCredentials.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMobileCredentialsAsync.rejected, (state) => {
      state.is_deleting_mobileCredentials = false
    })
  },
})

export const {
  clearStatemobileCredentials,
  setSelectedmobileCredentials,
  set_mobileCredentials,
  mergemobileCredentials,
  add_mobileCredentials,
} = mobileCredentialsSlice.actions

export const get_mobileCredentials =
  (id?: string) =>
  (state: {
    mobileCredentials: {
      mobileCredentials: MobileCredentials[]
    }
  }): MobileCredentials | null => {
    let temp = state?.mobileCredentials?.mobileCredentials?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mobileCredentials?.mobileCredentials[0] || null
  }
export const get_selected_mobileCredentials = (state: {
  mobileCredentials: mobileCredentialsSliceState
}): MobileCredentials | null => {
  let id = state?.mobileCredentials?.selected_mobileCredentials
  let temp = state?.mobileCredentials?.mobileCredentials?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mobileCredentials = (state: {
  mobileCredentials: {
    mobileCredentials: MobileCredentials[]
  }
}): MobileCredentials[] => {
  let temp = state?.mobileCredentials?.mobileCredentials
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mobileCredentials_busy = (state: {
  mobileCredentials: mobileCredentialsSliceState
}) => {
  return (
    state?.mobileCredentials.is_deleting_mobileCredentials ||
    state?.mobileCredentials.is_loading_mobileCredentials ||
    state?.mobileCredentials.is_creating_mobileCredentials
  )
}
export const is_deleting_mobileCredentials_busy = (state: {
  mobileCredentials: mobileCredentialsSliceState
}) => {
  return state?.mobileCredentials.is_deleting_mobileCredentials
}
export const is_loading_mobileCredentials_busy = (state: {
  mobileCredentials: mobileCredentialsSliceState
}) => {
  return state?.mobileCredentials.is_loading_mobileCredentials
}
export const is_creating_mobileCredentials_busy = (state: {
  mobileCredentials: mobileCredentialsSliceState
}) => {
  return state?.mobileCredentials.is_creating_mobileCredentials
}

export default mobileCredentialsSlice.reducer
